import { render, staticRenderFns } from "./TypographyIntroSection.vue?vue&type=template&id=82907244"
import script from "./TypographyIntroSection.vue?vue&type=script&lang=ts"
export * from "./TypographyIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyIntroSection.vue?vue&type=style&index=0&id=82907244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports